<script>
    import includes from 'lodash/includes'
    import get from 'lodash/get'
    import find from 'lodash/find'
    import findKey from 'lodash/findKey'
    import remove from 'lodash/remove'
    import filter from 'lodash/filter'
    import map from 'lodash/map'
    import forEach from 'lodash/forEach'
    import isArray from 'lodash/isArray'
    import sum from 'lodash/sum'
    import isEmpty from 'lodash/isEmpty'
    import Field from './../components/Field.vue'
    import Campaign from './../components/Campaign.vue'
    import axios from "axios"

    import EventBus from './../EventBus.js'

    export default {
        name: 'registration',
        props: [],
        components: {
            Field,
            Campaign,
        },
        data() {
            return {
		pmethod : '',
                plan: '',
		txtdesc : '',
                resetCounter: 0,
                currentStep: 1,
                minStep: 1,
                maxStep: 4,
                participants: [],
		participants_pet : [],
                participantCounter: 1,
		participantCounter_pet : 1,
		currentParticipant_pet : 1,
                currentParticipant: 1,
                step4Participant: 1,
		step4Participant_pet: 1,
                email: '',
		gametype : 0,
                brith_y: false,
                brith_m: false,
                brith_d: false,
                gender: false,
                groupInfo: {},
                campaignInfo: [],
                rerendering: false,
                guardianJoin: false,
                guardianApproval: false,
                basicField: {
                    timestamp: '',
                },
		raceDiscount: 0,
		raceDiscountAll : 0,
                promoCode: '',
                promoCodeSubmitted: false,
                promoCodeMsg: '',
		
		pmethod : 'paypal',
		busdesc : [],
                campaignField: {
                    data: [],
                    timestamp: '',
                },
                fieldTimestamp: '',

		step3d : {
			options : [0,0,0,0],
			qtys : [1,1,1,1],
			total : 0
		},
		shows4d : 0,
            }
        },
        mounted() {
            this.reset()
	    EventBus.$on('update-participant-field-pet', (index, key, value) => this.updateParticipantField_pet(index, key, value))
            EventBus.$on('update-participant-field', (index, key, value) => this.updateParticipantField(index, key, value))
            EventBus.$on('update-basic-field', (key, value) => this.updateBasicField(key, value))
            EventBus.$on('update-campaign-field', (id, key, value) => this.updateCampaignField(id, key, value))
            EventBus.$on('init-campaign', (info) => this.initCampaign(info))
        },
        computed: {
            numOfCampaignParticipants() {
                return sum(map(this.campaignField.data, (value) => {
                    return value.participants.length
                }))
            },
	    numOfCampaignParticipants_pet() {
                return sum(map(this.campaignField.data, (value) => {
                    return value.participants_pet.length
                }))
            },
            campaignConfirmed() {
                return isEmpty(filter(get(this, 'campaignField.data', []), {confirmed: false}))
            },
            groupContactEmail() {
                return get(this, '$refs[groupContactEmail].inputValue', '')
            },
            step2FieldComponents() {
                return {
                    timestamp: this.fieldTimestamp,
                    data: filter(get(this, '$children'), (v, k) => {
                        return v.$options.name === 'field' && v.scope === 'step2'
                    })
                }
            },
            campaignParticipants() {
                return filter(get(this, '$children'), (v, k) => {
                    return v.$options.name === 'campaign'
                })
            },

	    campaignBill() {
                var raceFee = this.plan == '' ? 0 : racePrice[this.plan];
                var activityFee = 0;
                forEach(this.campaignField.data, (value, index) => {
                    if (value.participants.length > 0) {
                        var price = activityPrice[value.info.id * 1 + 1].timeslots[value.timeslot].price;
                        activityFee += price * value.participants.length;
                    }
                });

                return {
                    raceFee: raceFee,
                    activityFee: activityFee,
                };
            },
            step3FieldComponents() {
                return filter(get(this, '$children'), (v, k) => {
                    return v.$options.name === 'field' && v.scope === 'step3'
                })
            },
            hasStep2FieldError() {
                return filter(this.step2FieldComponents.data, (v) => {
                    return get(v, 'status') === 'error'
                }).length > 0
            },
            globalVars() {
                return this.$root.globalVars
            },
            isGroup() {
                return get(this, 'planInfo.type', '').match(/company|interschool|experience/) ? true : false
            },
            isExp() {
                return (get(this, 'planInfo.type', '') === 'experience')
            },
            planInfo() {
                // 3公里個人賽 - 1
                // 10公里個人賽 - 2
                // 3公里校際賽 - 3
                // 10公里校際賽 - 4
                // 3公里企業賽 - 5
                // 10公里企業賽 - 6
                // 1公里體驗組 - 7
                // Pet 1 - 8 //1公里體驗組 - 8
		// Pet 2 - 9

                return find(get(globalVars, 'planInfo', []), {id: parseInt(this.plan)}) || false
            },
            avaliableYear() {
                let min = 0
                let max = 0
                let range = []

                if (get(this, 'planInfo.type', '').match(/company|interschool/)) {
                    min = 1900
                    max = 2003
                } else if (get(this, 'planInfo.type', '') === 'experience') {
                    min = 1900
                    max = 2016
		 } else if (this.selectedPlan(8) || this.selectedPlan(9)) {
                    min = 1900
                    max = 2016
                
                } else {
                    if (get(this, 'planInfo.distance') === 3) { // 3km
                        min = 1900
                        max = 2011
                    } else if (get(this, 'planInfo.distance') === 10) { // 10km
                        min = 1900
                        max = 2003
                    }
                }
                for (let i = max; i >= min; i--) {
                    range.push(i)
                }
                return range
            },
            birthYearRange() {
                let minY = 0
                let maxY = 0
                let minM = 0
                let maxM = 0
                let minD = 0
                let maxD = 0
                let range = {y: [], m: [], d: []}

                if (get(this, 'planInfo.type', '').match(/company|interschool/)) {
                    minY = 1900
                    maxY = 2001

                    minM = 1
                    maxM = 12

                    minD = 1
                    maxD = 31
                } else if (get(this, 'planInfo.type', '') === 'experience') {
                    minY = 1900
                    maxY = 2016

                    minM = 1
                    maxM = 12

                    minD = 1
                    maxD = 31
                } else {
                    if (get(this, 'planInfo.distance') === 3) { // 3km
                        minY = 1900
                        maxY = 2011
                    } else if (get(this, 'planInfo.distance') === 10) { // 8km
                        minY = 1900
                        maxY = 2003
                    }
                    minM = 1
                    maxM = 12

                    minD = 1
                    maxD = 31
                }

                for (let i = maxY; i >= minY; i--) {
                    range.y.push(i)
                }

                for (let i = maxM; i >= minM; i--) {
                    range.m.push(i)
                }

                for (let i = maxD; i >= minD; i--) {
                    range.d.push(i)
                }
                return range
            },
            birthMonthRange() {
                let min = 0
                let max = 0
                let range = []

                min = 1
                max = 12
                for (let i = min; i <= max; i++) {
                    range.push(i)
                }
                return range
            },
            birthDayRange() {
                let min = 0
                let max = 0
                let range = []

                min = 1
                max = 31
                for (let i = min; i <= max; i++) {
                    range.push(i)
                }
                return range
            },
            step4ParticipantInfo() {
                return get(this, `participants[${this.step4Participant - 1}]`, false)
            },

	    step4ParticipantInfo_pet() {
		//console.log(this.participants_pet)
	    	return get(this, `participants_pet[${this.step4Participant_pet - 1}]`, false)
	    }
        },
        methods: {
            includes,
            selectedPlan(num) {
		//console.log(this.plan+"="+num);
                return includes(this.plan, num.toString()) || includes(this.plan, num)
            },

	    showbb()
	    {
		    this.shows4d = 1 - this.shows4d;
	    }, 

	    picktype(a)
	    {
		    this.gametype = a;
	    }, 

	    getRowVisible(a)
	    {
		//console.log(this.gametype);
		//console.log(a);

		if ( ( (this.gametype == 1 || this.gametype == 2 ) && (a < 8 ) ) || ( (this.gametype == 3 ) && (a >= 8 )  ) )
			return true;
		else
			return false;
	    },

	    picks3(a)
	    {
		
		var r = this.step3d.options[a-1]
		r = 1- r;
		//alert(r);
		this.step3d.options[a-1] = r;
		//this.currentStep = 1;
		this.totalcount();
/*
		this.rerendering = true;
		console.log(this);
		this.$nextTick(() => {
                    this.rerendering = false
                })
		*/
	    },

	    step3d_options(a)
	    {
		var r = this.step3d.options[a-1]
		
		return r == 1;
	    },

	    step3d_qty(a)
	    {
		var r = this.step3d.qtys[a-1]

		return r ;
	    },

	    totalcount()
	    {
		let t = 0;
		this.txtdesc = "";
		this.busdesc = [];
		//globalVars.busInfo
		for (var j=0;j<this.step3d.qtys.length;j++)
		{
			if (this.step3d.options[j] == 1 )
			{

				var srow = {
					title : globalVars.busInfo[j].title,
					qty : this.step3d.qtys[j],
					cost : globalVars.busInfo[j].cost,
					dir : globalVars.busInfo[j].dir,
				}
				t += this.step3d.qtys[j] *  globalVars.busInfo[j].cost;

				this.txtdesc += this.step3d.qtys[j]+" x "+globalVars.busInfo[j].title+" \n";


				this.busdesc.push(srow);
			}
		}

		this.step3d.total = t;
	    },

	    picks3_opt(a , d)
	    {
		//alert(a + " " + d);
		var r = this.step3d.qtys[a-1]
		r = r + d;
		
		r = Math.max(r , 1);
		r = Math.min(r , globalVars.maxticket);
		//alert(this.step3d.qtys[a-1]);
		this.step3d.qtys[a-1] = r;
		
		this.totalcount();
		/*
		this.rerendering = true;
		console.log(this.step3d.qtys);
		this.$nextTick(() => {
                    this.rerendering = false
                })
		*/
	    },

            goTo(num) {
                if (num < this.currentStep) {
                    if (num < 2) {
                        const msg = this.currentStep > 2 ? get(this, 'globalVars.backwardWarning.step2n3.msg', '') : get(this, 'globalVars.backwardWarning.step2.msg', '')
                        if (confirm(msg)) {
                            this.reset()
                        } else {
                            return
                        }
                    } else if (num < 3) {
                        if (confirm(get(this, 'globalVars.backwardWarning.step3.msg', ''))) {
                            this.resetCampaignParticipants()
			   this.resetCampaignParticipants_pet()
                        } else {
                            return
                        }
                    }
                }

                if (this.currentStep === 3 && num > 3) {
                    if (!this.campaignConfirmed) {
                        alert(get(this, 'globalVars.campaignWarning', ''))
                        return
                    }
                }
                this.currentStep = num
                setTimeout(() => {
                    this.$vuetify.goTo(0)
                }, 0)
            },
            flyTo(num) {
                if (num < this.currentStep) {
                    this.goTo(num)
                }
            },
            inputMounted() {
            },
            resetParticipant() {
                this.participants = []
                for (let i = 0; i < get(this, 'planInfo.participantLimit.min', 0); i++) {
                    this.increaseParticipant()
                }
            },
	    resetParticipant_pet() {
                this.participants_pet = []
                var numnow =  (this.selectedPlan(8) || this.selectedPlan(9) ) ? 1 : 0; 
		for (let i = 0; i < numnow; i++) {
                    this.increaseParticipant_pet()
                }
            },
            increaseParticipant() {
                this.participants.push({
                    id: this.participantCounter,
                    fields: {
                        name: '',
                        first_name: '',
                        name: '',
                        timestamp: new Date().getTime()
                    },
                    disable_m: true,
                    disable_d: true,
                    monthRange: [],
                    dayRange: [],
                })
                this.participantCounter += 1
            },
	    increaseParticipant_pet() {
                this.participants_pet.push({
                    id: this.participantCounter_pet,
                    fields: {
                        petname: '',
                        type: '',
                        others: '',
			size: '',
                        timestamp: new Date().getTime()
                    }
                   
                })
                this.participantCounter_pet += 1
            },
            addParticipant() {
                if (this.participants.length < get(this, 'planInfo.participantLimit.max', 0)) {
                    this.increaseParticipant()
                    this.currentParticipant = this.participants.length
                }
            },
	    addParticipant_pet() {
                if (this.participants_pet.length < 2) {
                    this.increaseParticipant_pet()
                    this.currentParticipant_pet = this.participants_pet.length
                }
            },
            removeParticipant(key) {
                if (this.currentParticipant === this.participants.length) this.currentParticipant -= 1
                this.participants = remove(this.participants, (v, k) => k !== key)
                this.$nextTick(() => {
                    this.$vuetify.goTo('.step2-wrapper .participant-wrap', {
                        offset: 120,
                    })
                })
            },
	     removeParticipant_pet(key) {
                if (this.currentParticipant_pet === this.participants_pet.length) this.currentParticipant_pet -= 1
                this.participants_pet = remove(this.participants_pet, (v, k) => k !== key)
		/*
                this.$nextTick(() => {
                    this.$vuetify.goTo('.step2-wrapper .participant-wrap', {
                        offset: 120,
                    })
                })
		*/
            },
            next() {
                if (this.currentStep < this.maxStep) {
                    if (this.currentStep === 1) {
                        if (!this.plan && this.gametype > 0 ) {
                            alert('please select (step 1)')
                        } else {
                            this.goTo(this.currentStep + 1)
                        }
                    } else {
                        if (this.currentStep === 2) {
                            this.validateGuardian().then((result) => {
                                if (result.hasError) {
                                    alert(result.msg)
                                } else {
                                    this.validateStep2Fields().then(() => {
                                        if (this.hasStep2FieldError) {
                                            alert('請填寫必要項目\nPlease fill in the required fields');
                                        } else {

					    if (this.gametype == 3)
					    {
					    	console.log(this.participants_pet);
					    	if (this.selectedPlan(8))
						{
							if (this.participants_pet.length == 1 && this.participants_pet.length == 1 )
							{
								this.goTo(this.currentStep + 2)
							}
							else
								alert("每隊上限最多1人及1寵物，");
						}
						else if (this.selectedPlan(9) )
						{
							if (this.participants_pet.length >= 1 && this.participants_pet.length >= 1 )
							{
								this.goTo(this.currentStep + 2)
							}
							else
								alert("每隊最小1人及1寵物，");
						}
					    }
					    else
					    {
					    	if (this.gametype == 2 )
							this.goTo(this.currentStep + 2)
						    else
							this.goTo(this.currentStep + 2)
					    }

					    
                                        }
                                    })
                                }
                            })

                        } else {
                            this.goTo(this.currentStep + 1)
                        }
                    }
                }
            },
            validateGuardian() {
                return new Promise((resolve) => {
                    if (this.guardianJoin || this.guardianApproval) {
                        let participantBelow7 = false
                        let participantAbove18 = false
                        forEach(this.participants, (value) => {
                            if (value.fields.age >=3 && value.fields.age <= 7) {
                                participantBelow7 = true
                            } else if (value.fields.age >= 18) {
                                participantAbove18 = true
                            }
                        })

                        if (participantBelow7 && !participantAbove18) {
                            resolve({
                                hasError: true,
                                msg: get(globalVars, 'guardianWarning3t7', ''),
                            })
                        } else {
                            resolve({
                                hasError: false,
                                msg: '',
                            })
                        }
                    } else {
                        resolve({
                            hasError: false,
                            msg: '',
                        })
                    }
                })
            },
            nextParticipant() {
                if (this.currentParticipant < this.participants.length) {
                    this.currentParticipant += 1
                    this.$nextTick(() => {
                        this.$vuetify.goTo('.step2-wrapper .participant-wrap', {
                            offset: 120,
                        })
                    })
                }
            },
            reset() {
                this.rerendering = true
                this.resetCounter += 1
                this.resetParticipant()
		this.resetParticipant_pet()
                this.resetCampaign()
                this.resetGroupInfo()
                this.currentParticipant = 1
                this.step4Participant = 1
                this.$nextTick(() => {
                    this.rerendering = false
                })
            },
            resetCampaign() {
                this.campaignField = {
                    data: [],
                    timestamp: new Date().getTime(),
                }
            },
	    updateParticipantField_pet(index, key, value){
	    console.log("P");
	    	if (get(this, `participants_pet[${index}]`)) {
		    this.participants_pet[index]['fields'][key] = value
                    this.participants_pet[index]['fields']['timestamp'] = new Date().getTime()
		}
	    },
            updateParticipantField(index, key, value) {
                if (get(this, `participants[${index}]`)) {
                    this.participants[index]['fields'][key] = value
                    this.participants[index]['fields']['timestamp'] = new Date().getTime()
                    this.participants[index]['fields']['age'] = this.getAge(index)
                    this.participants[index]['fields']['ageGroup'] = this.getAgeGroup(index)
                    if (key === 'birth_y') {
                        this.$refs['birth_m'][index].inputValue = ''
                        this.$refs['birth_d'][index].inputValue = ''
                        this.participants[index].monthRange = this.getAvaliableMonth(this.participants[index]['fields']['birth_y'])
                    }

                    if (key === 'birth_m') {
                        this.$refs['birth_d'][index].inputValue = ''
                        this.participants[index].dayRange = this.getAvaliableDay(this.participants[index]['fields']['birth_y'], this.participants[index]['fields']['birth_m'])
                    }

console.log(this.$refs['birth_y'][index].inputValue);
                    this.participants[index].disable_m = (this.$refs['birth_y'][index].inputValue === '')
                    this.participants[index].disable_d = (this.$refs['birth_m'][index].inputValue === '')
                    if (this.isExp) {
                        this.requestGuardian()
                    }
                }
            },
            updateBasicField(key, value) {
                this.basicField[key] = value
                if (key === 'interested' || key === 'source') {
                    this.basicField[`combined_${key}`] = value.join('/')
                }
                this.basicField['timestamp'] = new Date().getTime()
            },
            updateCampaignField(id, key, value) {
                const campaignKey = findKey(get(this, 'campaignField.data'), {info: {id}})
                if (campaignKey) {
                    this.campaignField.data[campaignKey][key] = value
                    this.campaignField.timestamp = new Date().getTime()
                }
            },
            requestGuardian() {
                let guardianJoin = false
                let guardianApproval = false
                forEach(this.participants, (value) => {
                    if (value.fields.age >= 3 && value.fields.age <= 7) {
                        guardianJoin = true
                    }
                    if (value.fields.age >= 8 && value.fields.age < 16) {
                        guardianApproval = true
                    }
                })
                this.guardianJoin = guardianJoin
                this.guardianApproval = guardianApproval
            },
            updateGroupInfo(key, value) {
                if (isArray(value)) this.groupInfo['combind_' + key] = value.join(' / ')
                this.groupInfo[key] = value
            },
            updateEmailField(value) {
                this.email = value
            },
            updateBirthYear(value = false) {
                this.brith_y = value
            },
            updateBirthMonth(value = false) {
                this.brith_m = value
            },
            updateBirthDay(value = false) {
                this.brith_d = value
            },
            updateGender(value = false) {
                this.gender = value
            },
            validateStep2Fields() {
                this.updateFieldTimestamp()
                const step2Fields = filter(get(this, '$children'), (v, k) => {
                    return v.$options.name === 'field' && v.scope === 'step2'
                })
                const validations = map(step2Fields, (v) => {
                    return v.validateField()
                })
                return Promise.all(validations)
            },
            resetCampaignParticipants() {
                forEach(this.campaignParticipants, (v) => {
                    v.selected = []
                    v.currentStep = 1
                })
                forEach(this.campaignField.data, (value, index) => {
                    this.campaignField.data[index].timeslot = ''
                    this.campaignField.data[index].participants = []
		    this.campaignField.data[index].participants_pet = []
                })
                this.campaignField.timestamp = new Date().getTime()
            },
	    resetCampaignParticipants_pet() {
                
            },
            resetGroupInfo() {
                this.groupContactPersonInfo = {}
            },
            getAgeGroup(index) {
                const data = get(this, `participants[${index}][fields]`)
                if (get(data, 'birth_y') && get(data, 'birth_m') && get(data, 'birth_d') && get(data, 'gender') && get(this, 'planInfo.type') === 'person') {
                    const bday = new Date(`${this.zeroDate(get(data, 'birth_y'))}-${this.zeroDate(get(data, 'birth_m'))}-${this.zeroDate(get(data, 'birth_d'))}`).getTime()
                    const ageDifMs = new Date('2020-11-10').getTime() - bday
                    const ageDate = new Date(ageDifMs)
                    const age = Math.abs(ageDate.getUTCFullYear() - 1970)
                    const gender = get(data, 'gender') === 'female' ? 'F' : 'M'
                    let group = false
                    if (age >= 0 && age <= 11) group = 1
                    if (age >= 12 && age <= 15) group = 2
                    if (age >= 16 && age <= 29) group = 3
                    if (age >= 30 && age <= 39) group = 4
                    if (age >= 40 && age <= 49) group = 5
                    if (age >= 50 && age <= 59) group = 6
                    if (age >= 60) group = 7
                    return `${this.planInfo.distance}KM - ${gender}${group}`
                }
                return ''
            },
            getAge(index) {
                const data = get(this, `participants[${index}][fields]`)
                if (get(data, 'birth_y') && get(data, 'birth_m') && get(data, 'birth_d')) {
                    //const bday = new Date(`${this.zeroDate(get(data, 'birth_y'))}-${this.zeroDate(get(data, 'birth_m'))}-${this.zeroDate(get(data, 'birth_d'))}`).getTime()
                    //const bday = new Date(get(data, 'birth_y'), get(data, 'birth_m'), get(data, 'birth_d')).getTime()
                    //const ageDifMs = new Date('2020-11-11').getTime() - bday //Date.now() - bday
                    //const ageDate = new Date(ageDifMs)
                    //const age = Math.abs(ageDate.getUTCFullYear() - 1970)

                    var today = new Date('2020-11-10');
                    const dob = get(data, 'birth_y') + '-' + get(data, 'birth_m') + '-' + get(data, 'birth_d');
                    console.log('dob is ' + dob);
                    var birthDate = new Date(dob);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                        age = age - 1;
                    }

                    return age;
                }
                return false
            },

            zeroDate(val) {
                return Number(val) < 10 ? `0${val}` : val
            },
            initCampaign(info) {
                this.campaignField.data.push({
                    info,
                    timeslot: '',
                    participants: [],
		    participants_pet: [],
                    confirmed: true,
                })
                this.campaignField.timestamp = new Date().getTime()
            },
            getAvaliableMonth(year) {
                const min = 1
                let max = 12
                let range = []

                if (get(this, 'planInfo.type', '').match(/company|interschool/)) {
                    if (year === 2003) max = 11
                } else if (get(this, 'planInfo.type', '') === 'experience') {
                    if (year === 2016) max = 11
                } else if (get(this, 'planInfo.type', '') === 'person') {
                    if (get(this, 'planInfo.distance') === 3) { // 3km
                        if (year === 2011) max = 11
                    } else if (get(this, 'planInfo.distance') === 10) { // 10km
                        if (year === 2003) max = 11
                    }
                } else {

                }
                for (let i = min; i <= max; i++) {
                    range.push(i)
                }
                return range
            },
            getAvaliableDay(year, month) {
                const min = 1
                let max = new Date(year, month, 0).getDate()
                let range = []

                if (get(this, 'planInfo.type', '').match(/company|interschool/)) {
                    if (year === 2003 && month === 11) max = 10
                } else if (get(this, 'planInfo.type', '') === 'experience') {
                    if (year === 2016 && month === 11) max = 10
                } else if (get(this, 'planInfo.type', '') === 'person') {
                    if (get(this, 'planInfo.distance') === 3) { // 3km
                        if (year === 2011 && month === 11) max = 10
                    } else if (get(this, 'planInfo.distance') === 10) { // 10km
                        if (year === 2003) max = 10
                    }
                } else {

                }
                for (let i = min; i <= max; i++) {
                    range.push(i)
                }
                return range
            },
            updateFieldTimestamp() {
                this.fieldTimestamp = new Date().getTime()
            },

	    setpayment()
	    {
		
	    console.log(this.pmethod);
	    },

            validatePromoCode() {
                var _this = this;
                function callback(response) {
                    if (response.data.status === false) {
                        _this.promoCodeMsg = 'wrong promo code';
                        _this.promoCodeSubmitted = false;
                        _this.raceDiscount = 0;
			_this.raceDiscountAll  = 0 ;
                    } else {
                        _this.promoCodeMsg = '';
                        _this.promoCodeSubmitted = true;
                        if (response.data.discount === 'free') 
			{
			    _this.raceDiscountAll = response.data.discountall ;
                            _this.raceDiscount = _this.plan == '' ? 0 : response.data.discount;// racePrice[_this.plan];
                        } else {
			    _this.raceDiscountAll =  response.data.discountall;
                            _this.raceDiscount =_this.plan == '' ? 0 : response.data.discount;// racePrice[_this.plan];
                        }
                    }
                }
                axios.get('/race/validate-promo-code/' + this.plan + '/' + this.promoCode).then(
                    response => callback(response)
                );
            },

            cancelPromoCode() {
                this.promoCodeMsg = '';
                this.promoCodeSubmitted = false;
            },
        },
        watch: {
            plan() {
                this.reset()
            },
        }
    }
</script>
